// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../usr/lib/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../usr/lib/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bar-chart-medium-width{min-width:450px}`, "",{"version":3,"sources":["webpack://./webpack/assets/javascripts/react_app/components/ConfigReports/ConfigReports.scss"],"names":[],"mappings":"AAAA,wBACE,eAAA","sourcesContent":[".bar-chart-medium-width {\n  min-width: 450px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
